const COLOR_BLUE_GRAY_200 = 'border-blue-gray-200';

// https://github.com/creativetimofficial/material-tailwind/blob/main/documentation/react/typography.mdx
export const customGlobalTheme = {
  typography: {
    styles: {
      colors: {
        yellow: {
          color: "text-yellow-600",
          gradient: "bg-gradient-to-tr from-yellow-700 to-yellow-500",
        },
        red: {
          color: "text-red-600",
          gradient: "bg-gradient-to-tr from-red-700 to-red-500",
        },
      },
    },
  },
};

export const customInputTheme = {
  input: {
    styles: {
      variants: {
        outlined: {
        },
      },
    },
  },
};

export const customSelectTheme = {
  select: {
    styles: {
      variants: {
        outlined: {
          colors: {
            select: {
              gray: {
                close: {
                  borderColor: COLOR_BLUE_GRAY_200,
                },
                open: {
                  borderColor: "border-gray-900",
                  borderTopColor: "border-t-gray-900",
                },
                withValue: {
                  borderColor: COLOR_BLUE_GRAY_200,
                  borderTopColor: "border-t-blue-gray-200",
                },
              },
              close: {
                borderColor: COLOR_BLUE_GRAY_200,
                borderTopColor: "border-t-blue-gray-200",
              },
              open: {
                borderColor: "border-gray-900",
                borderTopColor: "border-t-gray-900",
              },
            }
          },
          error: {
            select: {
              states: {
                close: {
                  borderColor: "border-red-500",
                },
                open: {
                  borderColor: "border-red-500",
                  borderTopColor: "border-t-red-500",
                },
                withValue: {
                  borderColor: "border-red-500",
                  borderTopColor: "border-t-red-500",
                },
              },
            }
          },
        }
      }
    }
  }
};
